import { i18nType } from '../types/I18nTypes'
import { ClientConfigType } from './types'

export const getFlowwConfig = (t: i18nType): ClientConfigType => ({
   logoURL: '/assets/images/app_logo_image.svg',
   logoWidth: 255,
   mobileLogoWidth: 223,
   appMode: {
      LAUNCHING_MODE: {
         title: t('launchingMode.floww.title'),
         copyrightsText: t('launchingMode.floww.copyrights')
      }
   }
})

export const getMaudConfig = (t: i18nType): ClientConfigType => ({
   logoURL: '/assets/clientImages/ma-ud-latest-logo.svg',
   logoWidth: 336,
   mobileLogoWidth: 223,
   appMode: {
      LAUNCHING_MODE: {
         title: t('launchingMode.maud.title'),
         copyrightsText: t('launchingMode.maud.copyrights')
      }
   }
})

export const getApMaudConfig = (t: i18nType): ClientConfigType => ({
   logoURL: './assets/clientImages/ap_maud_logo.png', //NOTE: no logo present in this path, resolve it after using this config
   logoWidth: 420,
   mobileLogoWidth: 223,
   appMode: {
      LAUNCHING_MODE: {
         title: t('launchingMode.apMaud.title'),
         copyrightsText: t('launchingMode.apMaud.copyrights')
      }
   }
})

export const getOfficerPortalAdminConfig = (t: i18nType): ClientConfigType => ({
   logoURL: '/assets/clientImages/ma-ud-latest-logo.svg',
   logoWidth: 420,
   mobileLogoWidth: 223,
   appMode: {
      LAUNCHING_MODE: {
         title: t('launchingMode.officerPortalAdmin.title'),
         copyrightsText: t('launchingMode.officerPortalAdmin.copyrights')
      }
   }
})

export const getMaudAdminConfig = (t: i18nType): ClientConfigType => ({
   logoURL: '/assets/clientImages/ma-ud-latest-logo.svg',
   logoWidth: 336,
   mobileLogoWidth: 223,
   appMode: {
      LAUNCHING_MODE: {
         title: t('launchingMode.maudAdmin.title'),
         copyrightsText: t('launchingMode.maudAdmin.copyrights')
      }
   }
})
